// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { lock16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-lock': IconLock;
    }
}

/**
 * The icon component for the 'lock' icon
 */
export class IconLock extends IconSvg {
    public constructor() {
        super(lock16X16);
    }
}

registerIconSvg('icon-lock', IconLock);
export const iconLockTag = 'nimble-icon-lock';
